<template>
  <div class="not-found">
    <img src="@/assets/vectors/page_not_found.png" alt="404">
    <h1>Page Not Found</h1>
    <p>Oops! Looks like the page you’re looking for doesn’t exist.</p>
    <router-link :to="redirectPath">{{ buttonText }}</router-link>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const user = JSON.parse(localStorage.getItem('User'));
const redirectPath = ref(user ? '/dashboard' : '/login');
const buttonText = ref(user ? 'Back to Dashboard' : 'Back to Login');
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 100px;
}

.not-found img {
  width: 40%;
}

.not-found h1 {
  color: #2f182a;
  font-size: 2rem;
  font-weight: bold;
}

.not-found p {
  margin: 20px 0;
}

.not-found a {
  background-color: #2f182a;
  padding: 10px 20px;
  border-radius: 8px;
  color: #fff3e0;
}
</style>
